import { makeStyles } from "tss-react/mui";
import { Theme } from "@mui/material";

const useStyles = makeStyles()((theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column"
  },
  row: {
    display: "flex",
    flexDirection: "row-reverse"
  },
  toggler: {
    cursor: "pointer",
    marginLeft: 8,
    marginRight: 8,
    display: "flex",
    alignItems: "center",
    maxHeight: 24,
    userSelect: "none"
  },
  icon: {
    fontSize: 16,
    marginRight: 2
  },
  title: {
    width: 24
  }
}));

export default useStyles;
